(() => {
  if (customElements.get('tk-digital-consent')) return;
  const variants = new Set([66152151613789, 66158058996061, 66228604502365]);
  const statement = 'I request immediate supply of the digital workbook(s) in my basket and acknowledge that I lose my 14-day cancellation right once supply begins.';
  const fingerprint = items => items.filter(i => variants.has(Number(i.variant_id || i.id))).map(i => `${i.variant_id || i.id}:${i.quantity}`).sort().join(',');
  class DigitalConsent extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('input');
      this.button = this.parentElement.querySelector('[name="checkout"]');
      if (!this.button) return;
      this.box.checked = false;
      this.button.disabled = true;
      // Other cart apps may re-enable checkout after their own checks.
      if (typeof MutationObserver !== 'undefined') {
        this.buttonObserver = new MutationObserver(() => {
          if ((!this.box.checked || this.busy) && !this.allowed && !this.button.disabled) this.button.disabled = true;
        });
        this.buttonObserver.observe(this.button, {attributes:true, attributeFilter:['disabled']});
      }
      this.box.addEventListener('change', () => { this.button.disabled = !this.box.checked || this.busy; });
      this.handler = e => this.checkout(e);
      this.button.addEventListener('click', this.handler, true);
      this.form = this.button.form;
      this.submitHandler = e => { if (!this.allowed && e.submitter === this.button) this.checkout(e); };
      this.form?.addEventListener('submit', this.submitHandler, true);
    }
    disconnectedCallback() {
      this.buttonObserver?.disconnect();
      this.button?.removeEventListener('click', this.handler, true);
      this.form?.removeEventListener('submit', this.submitHandler, true);
    }
    async checkout(e) {
      if (this.allowed) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!this.box.checked || this.busy) return;
      this.busy = true; this.button.disabled = true;
      const error = this.querySelector('[data-consent-error]'); error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!response.ok) throw Error('cart');
        const cart = await response.json();
        const expected = this.dataset.items.split(',').filter(Boolean).sort().join(',');
        if (fingerprint(cart.items) !== expected) throw Error('changed');
        const attributes = {
          'Digital supply consent': statement,
          'Digital consent items': expected,
          'Digital consent recorded': new Date().toISOString(),
          'Digital consent version': '2026-10-10-v1'
        };
        const saved = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes})});
        if (!saved.ok) throw Error('save');
        const verified = await saved.json();
        if (fingerprint(verified.items) !== expected || Object.entries(attributes).some(([k,v]) => verified.attributes[k] !== v)) throw Error('verify');
        this.allowed = true; this.button.disabled = false;
        this.form.requestSubmit(this.button);
      } catch (_) {
        this.busy = false; this.box.checked = false; this.button.disabled = true;
        error.textContent = this.dataset.error; error.hidden = false;
      }
    }
  }
  customElements.define('tk-digital-consent', DigitalConsent);
  window.addEventListener('pageshow', e => {
    if (e.persisted) document.querySelectorAll('tk-digital-consent').forEach(el => {
      el.allowed = false; el.busy = false; el.box.checked = false; el.button.disabled = true;
    });
  });
})();

